// src/features/bpch/shampoo/results/ShampooResultsSection.jsx
import React from "react";
import CookiesResultsSection from "../../../fb/cookies/results/CookiesResultsSection";

/**
 * ShampooResultsSection - Wraps CookiesResultsSection with shampoo branding
 * Both cookies and shampoo use the same result structure
 */
export default function ShampooResultsSection(props) {
  return <CookiesResultsSection {...props} />;
}
